import {Box, Button, IconButton} from "@mui/material";
import React, {useState} from "react";
import {Column} from "../../types/Column";
import EditIcon from "@mui/icons-material/Edit";
import {ArmatecaArticle} from "./ArmatecaArticle";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {changeArmatecaArticleStatus, fetchArmatecaArticles} from "../../api/armateca-articles";
import {DataTable} from "../../components/DataTable";
import {ArticleStatusSelector} from "./StatusSelector";
import cogoToast from "cogo-toast";
import {ArticleEditor} from "../../components/ArticleEditor";

export const ArmatecaPage = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [tokens, setTokens] = useState<string[]>([]);
  const [nextPageToken, setNextPageToken] = useState<string | null>(null);
  const [currentEditableArticle, setCurrentEditableArticle] = useState<ArmatecaArticle | null>(null);

  const columns: Column<ArmatecaArticle>[] = [
    {
      label: "id",
      render: (article) => <>{article.ext_id}</>,
    },
    {label: "Заголовок", render: (article) => <>{article.title}</>},
    {label: "Анонс", render: (article) => <>{article.announcement}</>},
    {label: "Дата добавления", render: (article) => <>{new Date(article.created_at).toLocaleDateString()}</>},
    {label: "Темы", render: (article) => <>{article.subjects.map(el => el.name).join(', ')}</>},
    {label: "Автор", render: (article) => <>{article.author.nickname}</>},
    {
      label: "Действия",
      render: (article) => (
        <Box display="flex" gap={1}>
          <ArticleStatusSelector
            value={article.status}
            disabled={changeArmatecaStatusMutation.isPending}
            onChange={(newStatus) => changeArmatecaStatusMutation.mutate({ext_id: article.ext_id, status: newStatus})}
          />
          <IconButton
            aria-label="edit"
            key={article.ext_id}
            onClick={() => handleEditArticle(article)}
          >
            <EditIcon/>
          </IconButton>
        </Box>
      ),
    },
  ];

  const handleEditArticle = (article: ArmatecaArticle) => {
    setIsAddModalOpen(true)
    setCurrentEditableArticle(article)
  }

  const queryClient = useQueryClient();

  const changeArmatecaStatusMutation = useMutation({
    mutationFn: changeArmatecaArticleStatus,
    mutationKey: ["armateka-articles"],
    onSettled: () => queryClient.invalidateQueries({queryKey: ["armateka-articles"]}),
    onSuccess: () => {
      cogoToast.success('Статус статьи успешно обновлен');
    },
    onError: (e) => {
      cogoToast.error('Ошибка обновления статуса');
    }
  });

  const {data} = useQuery({
    queryKey: ["armateka-articles", rowsPerPage, nextPageToken],
    queryFn: () => fetchArmatecaArticles(rowsPerPage, nextPageToken),
  });

  const handleCloseModal = () => {
    setIsAddModalOpen(false)
    setCurrentEditableArticle(null)
  }

  return (
    <div>
      <Box p={2}>
        <Button onClick={() => setIsAddModalOpen(true)}>
          Добавить статью
        </Button>
      </Box>
      {data && (
        <DataTable
          rowsPerPageOptions={[20, 50, 100]}
          columns={columns}
          data={data.data}
          rowsPerPage={rowsPerPage}
          handleChangeRowsPerPage={(event) => {
            setRowsPerPage(+event.target.value);
          }}
          page={page}
          handleChangePage={(_, newPage) => {
            setPage(newPage);
            if (newPage > page) {
              setNextPageToken(data.next_page_token);
              setTokens((prev) => [...prev, data.next_page_token]);
            } else {
              setNextPageToken(tokens[newPage - 1]);
            }
          }}
          count={data?.total}
        />
      )}{" "}
      <ArticleEditor article={currentEditableArticle} handleClose={handleCloseModal} open={isAddModalOpen}/>
    </div>
  )
}